import React, { useState, useEffect } from 'react'
import styled from 'styled-components'
import { Modal } from 'vqp-common'
import { Button, Input } from '../common'
import { sanitizeText, validateTextInput } from '../../utils/sanitize'

const ModalContent = styled.div`
  padding: 24px;
  min-width: 320px;
`

const ModalTitle = styled.h2`
  font-size: 18px;
  font-weight: 600;
  color: ${(p) => p.theme.colors?.textBold || '#333'};
  margin: 0 0 20px 0;
  padding-bottom: 12px;
  border-bottom: 1px solid ${(p) => p.theme.colors?.lineGrey || '#e8e8e8'};
`

const Field = styled.div`
  margin-bottom: 20px;
`

const Label = styled.label`
  display: block;
  font-size: 13px;
  font-weight: 500;
  color: ${(p) => p.theme.colors?.textBold || '#555'};
  margin-bottom: 8px;
`

const ErrorText = styled.span`
  display: block;
  color: #dc3545;
  font-size: 12px;
  margin-top: 6px;
`

const Actions = styled.div`
  display: flex;
  justify-content: flex-end;
  align-items: center;
  gap: 12px;
  margin-top: 24px;
  padding-top: 16px;
  border-top: 1px solid ${(p) => p.theme.colors?.lineGrey || '#e8e8e8'};

  & > button {
    min-width: 100px;
    height: 36px;
  }
`

export const NewCategoryModal = ({ isOpen, onClose, onAdd }) => {
  const [name, setName] = useState('')
  const [error, setError] = useState('')

  useEffect(() => {
    if (isOpen) { setName(''); setError(''); }
  }, [isOpen])

  const handleChange = (value) => {
    setName(value);
    const check = validateTextInput(value);
    setError(check.valid ? '' : check.message);
  }

  const handleSubmit = () => {
    const clean = sanitizeText(name);
    if (!clean) return;
    const check = validateTextInput(name);
    if (!check.valid) { setError(check.message); return; }
    onAdd(clean);
    onClose();
  }

  const handleKeyDown = (e) => {
    if (e.key === 'Enter') handleSubmit()
  }

  return (
    <Modal isOpen={isOpen} onClose={onClose} boxWidth="400px">
      <ModalContent>
        <ModalTitle>Nova categoria</ModalTitle>
        <Field>
          <Label htmlFor="new-category-name">Nome da categoria</Label>
          <Input
            id="new-category-name"
            placeholder="Ex: Bebidas, Sobremesas..."
            value={name}
            onChange={handleChange}
            onKeyDown={handleKeyDown}
          />
          {error && <ErrorText>{error}</ErrorText>}
        </Field>
        <Actions>
          <Button onClick={onClose}>Cancelar</Button>
          <Button className="primary" onClick={handleSubmit} disabled={!name?.trim() || !!error}>
            Adicionar
          </Button>
        </Actions>
      </ModalContent>
    </Modal>
  )
}
